import { Component, inject } from '@angular/core';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonComponent } from '@components/buttons/button/button.component';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'app-hamburger-menu-bottom-sheet',
  imports: [MatBottomSheetModule, ButtonComponent, MatDividerModule, ImageGeneratorComponent],
  templateUrl: './hamburger-menu-bottom-sheet.component.html',
  styleUrl: './hamburger-menu-bottom-sheet.component.scss',
})
export class HamburgerMenuBottomSheetComponent {
  tokenService = inject(TokenService);
  bottomSheetRef = inject(MatBottomSheetRef<HamburgerMenuBottomSheetComponent>);

  close() {
    this.bottomSheetRef.dismiss();
  }
}
